const state = {
    mail_server_ssl_domain_id: 0,
};

const getters = {
    mailServerSslDomainId(state) {
        return state.mail_server_ssl_domain_id;
    },
};

const actions = {
    LoadMailServerSettings({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.load_mail_server_settings', {
                entity_id: request_data,
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
    SaveMailServerSettings({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.save_mail_server_settings', {
                entity_id: request_data.entity_id,
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    // mail ssl
    getEmailSslStatus({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.get_email_ssl_status', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        // todo: commit mutation for SslDomainId if success_data.mail_ssl_settings.length
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    createEmailSelfSigned({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.create_email_self_signed', {
                entity_id: request_data['entity_id']
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    getEmailCsrDefaults({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.get_email_csr_defaults', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.csr_defaults);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    getEmailLeDefaults({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.get_email_le_defaults', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.le_defaults);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    emailLeStart({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.email_le_start', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.le_op_id);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    emailGetCertificates({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.email_get_certificates', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.certificates);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    emailGetCertificate({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.email_get_certificate', {
                entity_id: request_data['entity_id'],
                crt_id: request_data['crt_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    emailDeleteCrt({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.email_delete_certificate', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    changeEmailCrtState({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.email_change_certificate_state', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    emailAddCrt({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('mail_server_settings.email_add_crt', {
                entity_id: request_data['entity_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error_message);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

};

const mutations = {
    setMailServerSslDomainId(state, mail_server_ssl_domain_id) {
        state.mail_server_ssl_domain_id = mail_server_ssl_domain_id;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};